import { AlertCircleIcon } from '@langchain/untitled-ui-icons';

import { cn } from '@/utils/tailwind';

export function TransformedExampleWarning({
  message,
  className,
}: {
  message: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-start justify-center gap-4 rounded-xl border border-tertiary p-4 shadow',
        className
      )}
    >
      <div className="relative h-5 w-5 rounded-[20px]">
        <div className="absolute left-[-4px] top-[-4px] h-7 w-7 rounded-3xl border-2 border-ls-orange-500 opacity-30" />
        <div className="absolute left-[-9px] top-[-9px] h-[38px] w-[38px] rounded-3xl border-2 border-ls-orange-500 opacity-10" />
        <div className="absolute left-0 top-0 h-5 w-5" />
        <AlertCircleIcon className="absolute left-0 top-0 h-5 w-5 text-ls-orange-500" />
      </div>
      <div className="inline-flex shrink grow basis-0 flex-col items-start justify-start gap-3">
        <div className="flex flex-col items-start justify-start gap-1 self-stretch">
          <div className="shrink grow basis-0 pr-8 text-sm leading-tight">
            {message}
          </div>
        </div>
      </div>
    </div>
  );
}
